import type { ReactNode } from 'react';

// Standard row-action icon buttons, matching legacy finkitRowEdit conventions.
// Shared by both table components (and re-exported from DataTable for back-compat).
export function RowActionButtons({
  onEdit,
  onDelete,
  extra,
}: {
  onEdit?: () => void;
  onDelete?: () => void;
  extra?: ReactNode;
}) {
  return (
    <div className="d-inline-flex gap-1 justify-content-center">
      {onEdit && (
        <button type="button" className="btn btn-sm btn-outline-primary fk-edit" title="Edit" onClick={onEdit}>
          <i className="fa fa-edit" />
        </button>
      )}
      {onDelete && (
        <button type="button" className="btn btn-sm btn-outline-danger fk-delete" title="Delete" onClick={onDelete}>
          <i className="fa fa-trash" />
        </button>
      )}
      {extra}
    </div>
  );
}
